module.exports = __webpack_public_path__ + "img/menu_pre _green.64bde81f.svg";